/* Confirmed storefront events; checkout completion belongs to Shopify Customer Events. */
(function () {
  'use strict';
  if (window.__bmMeasurement) return;
  window.__bmMeasurement = true;
  var node = document.getElementById('bm-measurement-context');
  if (!node) return;
  var context;
  try { context = JSON.parse(node.textContent); } catch (_) { return; }
  var viewed = false;
  var cart = { item_count: context.cart_count, value: context.cart_value };

  function capture(name, properties) {
    var ph = window.posthog;
    if (!window.BMAnalyticsReady || !ph || typeof ph.capture !== 'function') return false;
    if (typeof ph.has_opted_out_capturing === 'function' && ph.has_opted_out_capturing()) return false;
    ph.capture(name, Object.assign({ currency: context.currency, bm_event_version: 2, bm_environment: 'unknown' }, window.BMAnalyticsContext, properties));
    return true;
  }
  function view() {
    if (!viewed && context.item_id) viewed = capture('view_item', {
      items: [{ item_id: context.item_id, product_id: context.product_id, item_name: context.item_name, price: context.price }],
      value: context.price
    });
    if (!viewed && context.page_type === 'cart') viewed = capture('view_cart', cart);
  }
  document.addEventListener('bm:analytics-ready', view);
  view();

  // A homepage purchase is a valid product path. Count an actual visible title,
  // not every below-the-fold product merely included in the document.
  if (context.page_type === 'index' && typeof window.IntersectionObserver === 'function') {
    document.querySelectorAll('[data-bm-featured-product]').forEach(function (section) {
      var data = section.querySelector('[data-bm-featured-context]');
      var title = section.querySelector('[data-bm-purchase-panel] .product__title');
      if (!data || !title) return;
      var item;
      try { item = JSON.parse(data.textContent); } catch (_) { return; }
      if (!item.item_id || !Number.isFinite(item.price)) return;
      var visible = false, recorded = false;
      function record() {
        if (!visible || recorded || document.visibilityState === 'hidden') return;
        recorded = capture('view_item', { items: [item], value: item.price, item_list_id: 'homepage_featured' });
        if (recorded) {
          observer.disconnect();
          document.removeEventListener('bm:analytics-ready', record);
          document.removeEventListener('visibilitychange', record);
        }
      }
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.target === title) visible = entry.isIntersecting && entry.intersectionRatio >= 0.5;
        });
        record();
      }, { threshold: [0, 0.5] });
      observer.observe(title);
      document.addEventListener('bm:analytics-ready', record);
      document.addEventListener('visibilitychange', record);
    });
  }

  document.addEventListener('ajaxProduct:added', function (event) {
    var detail = event.detail || {};
    // The response may contain total line quantity. Use only the confirmed request delta.
    if (!Array.isArray(detail.requestedItems) || !detail.product) return;
    var lines = detail.product.items || [detail.product];
    var items = detail.requestedItems.map(function (requested) {
      var line = lines.find(function (entry) { return String(entry.variant_id || entry.id) === String(requested.id); });
      var quantity = Number(requested.quantity || 1);
      if (!line || !Number.isFinite(quantity) || quantity <= 0) return null;
      var price = Number(line.final_price == null ? line.price : line.final_price) / 100;
      if (!Number.isFinite(price)) return null;
      return { item_id: String(requested.id), product_id: String(line.product_id), item_name: line.product_title || line.title, price: price, quantity: quantity };
    }).filter(Boolean);
    if (items.length !== detail.requestedItems.length || !items.length) return;
    capture('add_to_cart', { items: items, value: items.reduce(function (total, item) { return total + item.price * item.quantity; }, 0) });
  });
  document.addEventListener('drawer:afterShow', function (event) {
    if (event.target.id === 'CartDrawer') capture('view_cart', cart);
  });
  document.addEventListener('click', function (event) {
    if (!event.target.closest) return;
    var checkout = event.target.closest('[name="checkout"], a[href]');
    if (checkout) {
      var isCheckout = checkout.name === 'checkout';
      if (checkout.tagName === 'A') {
        try { var url = new URL(checkout.href); isCheckout = url.origin === location.origin && /\/checkout\/?$/.test(url.pathname); } catch (_) { isCheckout = false; }
      }
      if (isCheckout && !checkout.disabled && checkout.getAttribute('aria-disabled') !== 'true') capture('checkout_click', cart);
    }
    var productLink = event.target.closest('.bm-tier a[href], .bm-hero a[href]');
    if (productLink) {
      try {
        var productUrl = new URL(productLink.href);
        var list = productLink.closest('.bm-hero') ? 'homepage_hero' : 'homepage_comparison';
        if (productUrl.origin === location.origin && productUrl.pathname.includes('/products/')) capture('select_item', { item_list_id: list, product_path: productUrl.pathname });
        else if (productUrl.origin === location.origin && productUrl.pathname === location.pathname && productUrl.hash) {
          var target = document.getElementById(decodeURIComponent(productUrl.hash.slice(1)));
          var info = target && target.matches('[data-bm-featured-product]') && target.querySelector('product-info[data-product-url]');
          if (info) {
            var targetUrl = new URL(info.getAttribute('data-product-url'), location.origin);
            if (targetUrl.origin === location.origin && targetUrl.pathname.includes('/products/')) capture('select_item', { item_list_id: list, product_path: targetUrl.pathname });
          }
        }
      } catch (_) { /* Ignore invalid editor links. */ }
    }
  });
  if (window.theme && theme.pubsub) {
    theme.pubsub.subscribe(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, function (event) {
      if (event.cart) cart = { item_count: event.cart.item_count, value: event.cart.total_price / 100 };
    });
    theme.pubsub.subscribe(theme.pubsub.PUB_SUB_EVENTS.variantChange, function (event) {
      var variant = event.data && event.data.variant;
      if (variant) capture('select_variant', { item_id: String(variant.id), price: variant.price / 100, available: variant.available });
    });
  }
})();
